export default __webpack_public_path__ + "61afe59831ecb508e15b8afe661cf454.jpg";